<p class="esf-paragraph">
  <ng-container *ngFor="let locale of locales; let last = last">
    <small *ngIf="('/' + locale + '/') !== currentBaseHref">
      <a [href]="hostURL + ('/' + locale + '/') + hostPath">{{locale.toUpperCase()}}</a>
    </small>
    <small *ngIf="('/' + locale + '/') === currentBaseHref">
      <span>{{locale.toUpperCase()}}</span>
    </small>
    <small *ngIf="!last">
      <span> | </span>
    </small>
  </ng-container>
<!--  <small *ngIf="currentBaseHref === '/en/'">
    <a [href]="hostURL + '/de/' + hostPath">DE</a>
    <span> | </span>
    <span>EN</span>
  </small>
  <small *ngIf="currentBaseHref === '/de/'">
    <span>DE</span>
    <span> | </span>
    <a [href]="hostURL + '/en/ + hostPath'">EN</a>
  </small>-->
</p>
<p class="esf-data" *ngIf="currentVersion">
  {{ currentVersion?.productVersion || 'product version' }}<br>
  be-{{ currentVersion?.backendVersion || 'local' }},
  fe-{{ currentVersion?.frontendVersion || 'local' }}<br>
  <span i18n='Text for developed by in the footer@@general.footer.developedBy'>developed by CTS EVENTIM Sports GmbH</span>
</p>
